/**
 * HeroReducedMotion — quiet branch for `prefers-reduced-motion: reduce`.
 *
 * Three Veo-derived keyframe stills stacked with mix-blend-mode lighten.
 * No scroll-scrub, no transforms — opacity only (handled by hero.css).
 *
 * v1.0.5 — the stills are now real frames extracted from the v1.0 cinematic
 * segments (arrival / heart / retreat) so this branch reads as the same
 * brand the cinematic visitors see. WCAG 2.3.3 still satisfied — no
 * amplitude-heavy motion, opacity blends only.
 */

export function HeroReducedMotion() {
  return (
    <section className="hero hero--reduced" data-scene="cinema">
      <div className="hero-reduced__stack">
        <figure className="hero-reduced__frame">
          <img
            src="/posters/reduced/frame-1-arrival.jpg"
            alt=""
            loading="eager"
            decoding="async"
          />
        </figure>
        <figure className="hero-reduced__frame">
          <img
            src="/posters/reduced/frame-2-heart.jpg"
            alt=""
            loading="eager"
            decoding="async"
          />
        </figure>
        <figure className="hero-reduced__frame">
          <img
            src="/posters/reduced/frame-3-retreat.jpg"
            alt=""
            loading="eager"
            decoding="async"
          />
        </figure>
      </div>
      <div className="hero-copy hero-copy--static">
        <p className="eyebrow">Brian Ellison Design — Melbourne, Florida</p>
        <h1 className="hero-copy__headline">
          Interiors composed like<br />
          <span className="display-italic">architecture</span>.
        </h1>
        <p className="subtitle">
          Multidisciplinary luxury interior design.
        </p>
        <a href="/projects" className="cta-primary">See the work</a>
      </div>
    </section>
  );
}
